// extracted by mini-css-extract-plugin
export default {"chatpage":"Chat_chatpage__td2LM","rcircle":"Chat_rcircle__sidCc","lcircle":"Chat_lcircle__msrBW","chatcontainer":"Chat_chatcontainer__PluUl"};